/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import s from './EServices.css';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import loadingData from './loading';
import _ from 'lodash';

import v from './validators';

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const AddressFormDict = {
  // Description: {
  //   label: "Opis planowanej inwestycji",
  //   editable: true
  // },
  // ParcelNo: {
  //   label: "Numer działki",
  //   editable: true
  // },
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy',
    editable: true,
  },
};

const LawBasic = {
  Paragraf: {
    label: 'Paragraf',
    editable: true,
  },
  Ustep: {
    label: 'Ustęp',
    editable: true,
  },
  Punkt: {
    label: 'Punkt',
    editable: true,
  },
};

class DecyzjaSrodowiskowa extends React.Component {
  state = {
    DecisionData: {
      AddressCity: null,
      AddressStreet: null,
      AddressFlat: null,
      AddressNumber: null,
      AddressZipCode: null,
    },
    BuildType: {
      BuildTypeName: null,
      BuildTypeType: null,
    },
    LawBasic: {
      Paragraf: null,
      Ustep: null,
      Punkt: null,
    },
    OtherBuildCharacteristics: {
      CharacteristicParams: '',
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    loading: false,
    isMounted: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    AddressCity: [v.NotNull, v.MinLength(2)],
    AddressStreet: [],
    AddressFlat: [],
    AddressNumber: [v.NotNull],
    AddressZipCode: [v.NotNull, v.checkZipCode],
    Paragraf: [v.NotNull],
    Ustep: [v.NotNull],
    Punkt: [v.NotNull],
    CharacteristicParams: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    this.setState({ isMounted: true });
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  render_info = (group, key) => (
    <span>
      <b>{this.state[group][key] ? this.state[group][key] : this.elseString}</b>
    </span>
  );

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      for (const g of ['DecisionData', 'BuildType', 'LawBasic', 'OtherBuildCharacteristics']) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      DecisionData: {
        AddressCity: 'Warszawa',
        AddressStreet: 'Koncertowa',
        AddressFlat: 9,
        AddressNumber: 6,
        AddressZipCode: '02-787',
      },
      BuildType: {
        BuildTypeName: 'testowy',
        BuildTypeType: 'testowy',
      },
      LawBasic: {
        Paragraf: '15',
        Ustep: '4',
        Punkt: '4',
      },
      OtherBuildCharacteristics: {
        CharacteristicParams: 'ferma trzody chlewnej o obsadzie 600 DJP',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
      return;
    }
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      return this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          DecisionData: { ...this.state.DecisionData },
          BuildType: { ...this.state.BuildType },
          LawBasic: { ...this.state.LawBasic },
          OtherBuildCharacteristics: { ...this.state.OtherBuildCharacteristics },
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.redirectToSummary(resp.jobId);
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const {
      errorSpanStyle,
    } = PanelStyle;
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <DecisionContainer
          title={'1. Adres'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={AddressFormDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </DecisionContainer>

        <GrayPanel title={'Planowane przedsięwzięcie:'}>
          <p style={{ textAlign: 'justify' }}>
            Nazwa planowanego przedsięwzięcia oraz krótki opis (np. ferma trzody chlewnej o obsadzie
            600 DJP):
            <textarea
              name="CharacteristicParams"
              style={{
                width: '100%',
                borderColor:
                  Object.keys(this.state.errors).indexOf('CharacteristicParams') > -1 &&
                  this.state.errors.CharacteristicParams !== null &&
                  this.state.errors.CharacteristicParams.length > 0
                    ? 'red'
                    : '#ccc',
              }}
              className="form-control"
              rows={10}
              value={this.state.OtherBuildCharacteristics.CharacteristicParams}
              onChange={e => this.onChange(e, 'OtherBuildCharacteristics')}
            />
            {/* RENDER ERROS IN SPAN */}
            {Object.keys(this.state.errors).indexOf('CharacteristicParams') > -1 &&
            this.state.errors.CharacteristicParams !== null &&
            this.state.errors.CharacteristicParams.length > 0
              ? this.state.errors.CharacteristicParams.map((val, index) => (
                <span key={index} style={errorSpanStyle}>
                  {val}
                </span>
                ))
              : null}
          </p>
        </GrayPanel>

        <DecisionContainer
          title={'Podstawa prawna: '}
          data={this.state.LawBasic}
          errors={this.state.errors}
          formDict={LawBasic}
          onChange={e => this.onChange(e, 'LawBasic')}
        />

        <GrayPanel title={'Planowane przedsięwzięcie:'}>
          <p style={{ textAlign: 'justify' }}>
            Do wniosku o wydanie decyzji należy załączyć, w uzgodnieniu z organem właściwym do
            wydania decyzji:
          </p>
          <ol>
            <li>
              <p>
                w przypadku przedsięwzięć mogących zawsze znacząco oddziaływać na środowisko –
                raport o oddziaływaniu przedsięwzięcia na środowisko, a w przypadku gdy wnioskodawca
                wystąpił o ustalenie zakresu raportu w trybie art. 69 – kartę informacyjną
                przedsięwzięcia;
              </p>
            </li>
            <li>
              <p>
                w przypadku przedsięwzięć mogących potencjalnie znacząco oddziaływać na środowisko –
                kartę informacyjną przedsięwzięcia;
              </p>
            </li>
            <li>
              <p>
                poświadczoną przez właściwy organ kopię mapy ewidencyjnej obejmującej przewidywany
                teren, na którym będzie realizowane przedsięwzięcie, oraz obejmującej obszar, na
                który będzie oddziaływać przedsięwzięcie;
              </p>
            </li>
            <li>
              <p>
                w przypadku przedsięwzięć wymagających decyzji, o której mowa w art. 72 ust. 1 pkt.
                4 lub 5, prowadzonych w granicach przestrzeni niestanowiącej części składowej
                nieruchomości gruntowej, zamiast kopii mapy, o której mowa w pkt. 3 – mapę
                sytuacyjno-wysokościową sporządzoną w skali umożliwiającej szczegółowe
                przedstawienie przebiegu granic terenu, którego dotyczy wniosek, oraz obejmującą
                obszar, na który będzie oddziaływać przedsięwzięcie;
              </p>
            </li>
            <li>
              <p>
                wypis z ewidencji gruntów obejmujący przewidywany teren, na którym będzie
                realizowane przedsięwzięcie oraz obejmujący obszar, na który będzie oddziaływać
                przedsięwzięcie.
              </p>
            </li>
          </ol>
        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DecyzjaSrodowiskowa.contextTypes = {
  fontSizeScale: React.PropTypes.number,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(DecyzjaSrodowiskowa),
);



// WEBPACK FOOTER //
// src/routes/eservices/DecyzjaSrodowiskowa.js